// src/utils/apiConfig.js
import loadApiEndpoints from './loadApiEndpoints.js';

// This object will hold the loaded API configuration
const apiConfig = {
    API_BASE_URL: "",
    enquiryUrl: "",
    schoolErpLanding: ""
};

// Function to initialize the apiConfig object
const initializeApiConfig = async () => {
    try {
        const endpoints = await loadApiEndpoints();
        // console.log(endpoints)
        apiConfig.API_BASE_URL = endpoints.API_BASE_URL;
        apiConfig.enquiryUrl = endpoints.enquiryUrl;
        apiConfig.schoolErpLanding = endpoints.schoolErpLanding;

    } catch (error) {
        console.error("Failed to load API configuration:", error);
        apiConfig.API_BASE_URL = "http://localhost:3000";
        apiConfig.enquiryUrl = "http://localhost:3000";
        apiConfig.schoolErpLanding = false;
    }
};

// Immediately invoke to start loading the config
initializeApiConfig();

// Export the apiConfig object.
// Components will import this, and its properties will be populated asynchronously.
export default apiConfig;